import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { Members } from '../features/selfservice/members/components/Members'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const MembersPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <Members />
    </ErrorBoundary>
  )
}
